export const heroContent = {
  eyebrow: 'CAPSOS TELECOMUNICACIONES',
  title: 'Más de tres décadas conectando a nuestra comunidad',
  description: 'Historia, identidad, principios y proyección de una organización construida junto a Santa Rosa de Osos.',
  ctaLabel: 'Conocer nuestra historia',
  targetSection: 'historia',
};
